const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.16602 13.3333L10.4993 10M10.4993 10L13.8327 13.3333M10.4993 10V17.5M17.166 13.9524C18.1839 13.1117 18.8327 11.8399 18.8327 10.4167C18.8327 7.88536 16.7807 5.83333 14.2493 5.83333C14.0673 5.83333 13.8969 5.73833 13.8044 5.58145C12.7177 3.73736 10.7114 2.5 8.41602 2.5C4.96424 2.5 2.16602 5.29822 2.16602 8.75C2.16602 10.4718 2.86222 12.0309 3.98847 13.1613",
  stroke: "#1E3F6B",
  strokeWidth: 1.66667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgUploadCloud = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/upload-cloud.b9a3d321.svg";
export { ForwardRef as ReactComponent };